import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import {required,email,isValidForm} from './../../../../server/validationMethods.js'
import Draft from './draft';
class AddChild extends Component {
    constructor(props){
        super(props);
        this.state={
            'hasError':false
        }
        this.validateFields=this.validateFields.bind(this)
        this.getSelectedStudentsNames=this.getSelectedStudentsNames.bind(this)
        this.childComponentRef = React.createRef();
    }
    getSelectedStudentsNames=()=>{
        let studentNames=[]
        this.props.lunchObj.studentList.map((student)=>{
            if(student.isSelected){
                studentNames.push(student.lname+' '+student.fname)
            }
        });
       return studentNames.join(', ')
    }
    validateFields=()=>{
        let parentError=true;
        parentError=this.props.lunchObj.childList.every((adult)=>{
            return adult.fname!='' && adult.lname!=''
        });
        if(parentError){
            return true
        }
        return false
    }
render(){
    const {lunchObj}=this.props
    const { t, i18n } = this.props;
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><Trans>Okay, it looks like we will need more information about your household and income in order to determine if you are eligible for benefits</Trans>.</p>
                        <p><Trans>Let's talk about the other kids in the house, and then we'll move on to the adults</Trans>. <Trans>Other than</Trans> <strong>{this.getSelectedStudentsNames()}</strong> <Trans>are there any other children in your household? Don’t forget to include</Trans>: </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <p><ul>
                       <li style={{listStyleType: 'disc'}}><Trans>Students who are in Grade 12 or below and attend school in a district other than</Trans> <strong>{this.props.schoolInfo.name}</strong></li>
                                               <li style={{listStyleType: 'disc'}}><Trans>Children who attend day care or pre-school, or are not school age, including infants</Trans></li>
                                               <li style={{listStyleType: 'disc'}}><Trans>Anyone 18 years of age or younger living in your household who does not currently attend school</Trans></li>
                    </ul></p>
                </div>
            </div>
           {/*   <Form ref={f=>this.frmPrimAdultInfo=f}>  */}
          
            <div className="row">
                <div className="col-xs-12">
                <ul>                
                {
                    (this.props.lunchObj.childList||[]).map((child,k)=>{
                        return(
                            <li><div className="row">
                                <div className="col-md-3" style={{paddingBottom:'10px'}}>
                                    <input type="text" data-idx={k} name="fname" className="form-control" placeholder={t('First Name')} value={child.fname}
                                    // validations={[required]} requiredmsg='Please provide first name.' 
                                    onChange={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onFieldValueChange(_idx,e.target.name,e.target.value)
                                    }} />
                                </div>
                                <div className="col-md-2">
                                    <input type="text" data-idx={k} name="lname" className="form-control" placeholder={t('Last Name')} value={child.lname}
                                    // validations={[required]} requiredmsg='Please provide last name.'
                                     onChange={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onFieldValueChange(_idx,e.target.name,e.target.value)
                                    }} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3" style={{paddingTop:'22px'}}>
                                <div className="styled-input-container styled-input--square">
                                    <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                        <input id={'stud'+k} checked={child.liveUnderFosterCare} data-idx={k} type='checkbox' onChange={(e)=>{
                                            let _idx=e.target.getAttribute('data-idx');
                                            this.props.onFieldValueChange(_idx,'liveUnderFosterCare',e.target.checked?true:false);                                                                                     
                                        }} /> 
                                        <label htmlFor={'stud'+k}>
                                        <Trans>{'Foster Child'}</Trans></label>
                                     </div>
                                </div>
                                </div>
                                <div className="col-md-2">
                                    <button type="button" data-idx={k} onClick={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onDeleteChild(_idx);
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }} className="btn btn-xs btn-danger"> <Trans>Remove child</Trans></button>
                                </div>                                
                            </div></li>
                        )
                    })
                }
                </ul>
                    
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-center">
                    <button type="button" className="btn btn-xs btn-success" onClick={(e)=>{
                        this.props.onAddNewChild();
                        this.childComponentRef.current.formatDraftReqObj();
                    }}><Trans>+ Add another child</Trans></button>
                </div>
            </div>            
            {/* </Form> */}
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validateFields()) && this.state.hasError? <span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }</p>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                            let homelessList=this.props.lunchObj.studentList.filter((student)=>{
                                    return (student.isSelected && student.liveUnderFosterCare===false)
                                })
                               let selectEvery= homelessList.every((student)=>{
                                    return (student.runaway===true)})
                                if(selectEvery){
                                    this.props.jumpToStep(7)

                                }else{
                                    this.props.jumpToStep(6)
                                }                        
                    }}>
                        <Trans>Back</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        if(this.props.lunchObj.childList.length>0){
                            //this.frmPrimAdultInfo.validateAll();
                            //if(!isValidForm(this.frmPrimAdultInfo)){
                             //   return false;
                            //}
                            if(!this.validateFields()){
                                this.setState({hasError:true});
                                return false;
                            }
                        }
                        this.props.jumpToStep(9);
                    }}><Trans>
                        {`${this.props.lunchObj.childList.length>0?'Continue':'No other children'}`}
                        </Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} />
                </div>
            </div>
        </div>
    )
}
}
export default  translate("translations")(AddChild);


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/addChild.jsx